import '../App.css';
import Background from '../assets/Background.jpg';

const Banner = () => {
    return (
        <div className='App-banner' style={{ backgroundImage: `url(${Background})` }}>
            <div className='Section'>
                <div className='Heading'>
                <div>Hello!<span className='wave'>👋</span></div>
                </div>
                <div className='Subheading'>
                    Welcome to my website.
                </div>
            </div>
        </div>
    );
}

export default Banner;